/*
 * @Description:
 * @Author: ywj
 * @Date: 2025-01-22 15:37:14
 * @LastEditTime: 2025-04-18 14:35:17
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2025-02-20 17:34:49
 * @LastEditors: Please set LastEditors
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { menuNav } from './config';
import cartIcon from './img/cart.svg';
import { MenuProps, message } from 'antd';
import { Dropdown, Space } from 'antd';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setUserInfo, setLoginStatus, setCartCount, setApplyCount } from '@/features/user/userSlice';
import { orderCountTotal } from '@/api/personal-center';
import { decMsg, getPk } from '@/utils/kyberSm2';
import { goLogin, goRegister } from '@/utils/index';
import { encryUserInfo, logout } from '@/api/login';
import './index.scss';

interface ILogin {
  loginState: boolean;
  userInfos: any;
  loginSuccess: any;
}
const LoginBox: React.FC<ILogin> = ({ loginState, userInfos, loginSuccess }) => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const handleLogOut = () => {
    logout().then((res: any) => {
      if (res.data.success) {
        message.success(res.data.message);
        dispatch(setUserInfo({}));
        dispatch(setLoginStatus(false));
        dispatch(setCartCount(0));
        dispatch(setApplyCount(0));
        localStorage.removeItem('loginToken');
        localStorage.removeItem('kyberSmKey');
        navigate('/home');
        loginSuccess();
      }
    });
  };
  const items: MenuProps['items'] = [
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="/user">
          个人中心
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a  href="/user/receipt">
          我的发票
        </a>
      ),
      key: '1',
    },

    {
      label: <span onClick={handleLogOut}>退出登录</span>,
      key: '3',
    },
  ];
  const handleLogin = () => {
    goLogin();
    // window.location.href=`${process.env.REACT_APP_LOGIN_URL}/zh/l/login`
  };
  const handleRegister = () => {
    // window.location.href=`${process.env.REACT_APP_LOGIN_URL}/zh/l/register`
    goRegister();
  };

 
  return (
    <>
      {loginState ? (
        <>
          <Dropdown
            menu={{ items }}
            className="header-dropdown"
            getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
            // getPopupContainer={() => document.getElementsByClassName('header-dropdown')[0]||document.body}

            overlayClassName="custom-head-dropdown"
          >
            <div>
              <span className="dropdown-title">{userInfos?.name}</span>
              <span className="line">|</span>
            </div>
          </Dropdown>
        </>
      ) : (
        <>
          <div className="header-content-right-item">
            <p className="header-text" onClick={handleLogin}>
              请登录<span className="line">|</span>
            </p>
          </div>
          <div className="header-content-right-item">
            <p className="header-text" onClick={handleRegister}>
              注册<span className="line">|</span>
            </p>
          </div>
        </>
      )}
    </>
  );
};
function Header() {
  const [activeId, setActiveId] = React.useState<number>(3);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loginState, setLoginState] = useState(false);
  const [userInfos, setUserInfos] = useState<any>({});
  const { cartCount } = useAppSelector(state => state.user);
  useEffect(() => {
    loginSuccess();
  }, []);
  // 获取购物车数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setCartCount(oRes.obj?.cartNum??0));
        dispatch(setApplyCount(oRes.obj?.apply??0))
      }
    })
  }
  // 用户信息
  const loginSuccess = async (): Promise<void> => {
    const { cipher1, cipher2, salt } = await getPk(true);
    const useRes = await encryUserInfo({ cipher1, cipher2, salt });
    const userData = useRes?.data;
    if (userData?.success) {
      const useinfoRes = await decMsg(userData?.obj?.user ?? '', salt);
      const getUser = JSON.parse(useinfoRes ?? '');
      dispatch(setUserInfo(getUser));
      dispatch(setLoginStatus(true));
      setLoginState(true);
      setUserInfos(getUser);
      cartCountFunc();
    } else {
      setLoginState(false);
      setUserInfos({});
    }
  };
  // useEffect(() => {
  //   loginSuccess();
  // }, [])

  const handleOrder = () => {
    if (!loginState) {
      //未登录，先登录
      // window.location.href = `${process.env.REACT_APP_LOGIN_URL}/zh/l/login`;
      goLogin();
    } else { 
      window.open('/user/orderList');
    }
  };
  const handleCart = () => {
    if (!loginState) {
      // window.location.href = `${process.env.REACT_APP_LOGIN_URL}/zh/l/login`;
      goLogin();
    }else {
      navigate('/user/cart');
    }
  };
  return (
    <div className="header-container">
      <div className="header-content">
        <div className="header-content-left">
          {menuNav.map((item, index) => {
            return (
              <div className="header-content-left-item" key={item.id}>
                <a href={item.link} target={item.target} className={`${activeId === item.id ? 'highlight header-text' : 'header-text'}`}>
                  {item.title}
                  {index < menuNav.length - 1 && <span className="line">|</span>}
                </a>
              </div>
            );
          })}
        </div>
        <div className="header-content-right">
          {/* <div className="header-content-right-item" >
              <p className='header-text'>请登录<span className='line'>|</span></p>
          </div>
          <div className="header-content-right-item" >
          <p className='header-text'>注册<span className='line'>|</span></p>
          </div> */}
          <LoginBox loginState={loginState} userInfos={userInfos} loginSuccess={loginSuccess} />
          <div className="header-content-right-item">
            <p className="header-text" onClick={handleOrder}>
              我的订单
            </p>
          </div>
          <div
            className={ `header-content-right-item  ${cartCount>0?'cart-box cart-box-active' :'cart-box'}`}
          >
            <p className="header-text" onClick={handleCart}>
              <img src={cartIcon} alt="购物车" className="cart" />
              购物车（{cartCount}）
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
